import React, { useMemo } from "react";
import { map } from "jquery";
import { CartItem, Ticket } from "../../../types/models/mvcapi";
import { useIFrameResize } from "../../../logic/hooks/utils";

const accounting = require('accounting');

type MembershipCardItemLabelProps = {
    cartItems: CartItem[];
}; 

export function MembershipCardItemLabel({ cartItems }: MembershipCardItemLabelProps) {
    useIFrameResize();
    
    const activeCards = useMemo(() => map(cartItems, (item) => {
        const cartItems = [];
        item.Tickets.forEach((ticket: Ticket) => {
            cartItems.push(<div key={"cartItem_" + cartItems.length} className="cart-item">
                <div className="item-info">
                    <div>{ticket.SeatName}</div>
                    <div className="price">{accounting.formatMoney(ticket.Total)}</div>
                </div>
                <div>{ticket.PriceName}</div>
            </div>);
        });
        return cartItems;
    }), [cartItems]);

    return (cartItems.length > 0 && <div>
            <div className="cart-item-label">{activeCards}</div>
        </div>
    );
}